export const HERO_HEIGHT = 90;
export const CLIENT_HEIGHT = Math.min(window.innerHeight, 640);
export const HERO_CLIENT_Y = CLIENT_HEIGHT - HERO_HEIGHT;
export const MAX_PAITICIPANTS_NUMBER = 3;
export const MAX_LIFE_NUMBER = 3;
export const HIT_INTERVAL = 1000;
export const SPEED_UP_TIME = 500;
export const INITIAL_SPEED = 4;
